import { LocaleContextType } from '@melements/front-components/dist/context/locale/localeContext/LocaleContext.types';

export const getErrorMessage = (error: any, localeContext: LocaleContextType): string => {
  return error.payload && error.payload.response && error.payload.response.message
    ? error.payload.response.message
    : localeContext.formatMessage({ id: 'ERROR.TITLE' });
};
